// extracted by mini-css-extract-plugin
export var aircallIframe = "_gd-3";
export var fabContainer = "_gd-5";
export var fabRinging = "_gd-6";
export var loadingOverlay = "_gd-4";
export var pulse = "_gd-7";
export var widgetContent = "_gd-2";
export var widgetPanel = "_gd-0";
export var widgetPanelExpanded = "_gd-1";